import React, { Component, useEffect, useState } from 'react';
import CategoryIcon from './categories/category-icon';
import CategoryIcons from '../category-icons/category-icons';
import HCNPrice from '../../helpers/hcn-price';
import ItemModel from '../../data/item-model';
import { useDispatch } from 'react-redux';
import RootCategoryItemsModal from './rootCategory-items-modal';
import ReactModal from 'react-modal';
import './rootCategory-items.css';
import HCNLoader from '../../helpers/hcn-loader';
import ProviderModel from '../../data/provider-model';
import InfoModal from '../info-modal';
import HCNImages from '../../helpers/hcn-images';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import RootCategoryModel from '../../data/rootCategory-model';
import { getTranslatedText } from '../../helpers/checkTranslations';
import { store } from '../../redux/store';
import Config from '../../Config';

const customStyles = {
    content: {
        top: '0',
        left: 'auto',
        right: '0',
        bottom: 'auto',
        width: '500px',
        backgroundColor: 'black',
    },
};

const RootCategoryItems = ({ selectedCategory, setSelectedCategory, categoryItems, setCategoryItems, active }) => {

    const [show, setShow] = useState(false);
    const [showIM, setShowIM] = useState(false);
    const [infoMessage, setInfoMessage] = useState({
        message: '',
        confirmation: false,
    });
    const [edited, setEdited] = useState(false);
    const [newItem, setNewItem] = useState({});
    const [draggedList, updateDraggedList] = useState(null);

    const history = useHistory();

    const dispatch = useDispatch();


    const isDineIn = Config.getDineIn();

    useEffect(() => {
        if (infoMessage.confirmation) {
            HCNLoader.show(dispatch);
            ItemModel
                .deleteRootCategoryCategoryItem(selectedCategory.id, infoMessage.itemId)
                .then(() => {
                    setCategoryItems(categoryItems.filter(item => item.id !== infoMessage.itemId));
                    HCNLoader.hide(dispatch);
                })
                .catch(err => {
                    toast(err.message);
                    HCNLoader.hide(dispatch);
                });
        }
        return () => {
            setInfoMessage({});
        };
    }, [infoMessage.confirmation]);

    useEffect(() => {
        updateDraggedList(categoryItems)
    }, [categoryItems])

    const removeCategoryItem = id => {
        setShowIM(true);
        setInfoMessage({
            ...infoMessage,
            message: getTranslatedText('deleteCategoryItemWarning', store),
            itemId: id,
        });
    };

    const openModal = () => {
        setShow(true);
    };

    const closeModal = () => {
        setShow(false);
    };

    const hideIMModal = () => {
        setShowIM(false);
    };

    const changeRootCategoryItemAvailability = (item, value) => {

        const itemToUpdate = categoryItems.find(x => x.id === item)
        console.log({ itemToUpdate })

        itemToUpdate && HCNLoader.show(dispatch);

        ItemModel
            .updateItem({
                ...itemToUpdate,
                available: value,
                filters: itemToUpdate?.filters.map(x => x.id),
                modifiers: itemToUpdate?.modifiers.map(x => x.id),
                taxes: itemToUpdate?.taxes.map(x => x.name),
                upsells: itemToUpdate.upsells,
            }, itemToUpdate.id)
            .then(res => {
                HCNLoader.hide(dispatch);
            })
            .catch(err => {
                toast.error(err.message);
                HCNLoader.hide(dispatch);
            });
    };

    const enableInput = () => {
        setEdited(!edited);
    };


    const handleOnDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const items = Array.from(draggedList);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        updateDraggedList(items);
        setCategoryItems(items);
        setTimeout(() => {
            RootCategoryModel.putOrderItemsInRootCategoryCategories(selectedCategory.id, draggedList.map(d => d.id))
                .then(res => console.log({ res }))
                .catch(err => console.log(err))
        }, 500);
    };

    return (
        <div className="tab-windows options-wrapper active" data-tab="tab-1">
            <InfoModal
                setInfoMessage={setInfoMessage}
                infoMessage={infoMessage}
                hideModal={hideIMModal}
                show={showIM} />
            <ReactModal
                isOpen={show}
                ariaHideApp={false}
                style={customStyles}
            >
                <RootCategoryItemsModal
                    show={show}
                    closeModal={closeModal}
                    type={'category'}
                    active={active}
                    featureSection={selectedCategory}
                    featureSectionItems={categoryItems}
                    setFeatureSectionItems={setCategoryItems}
                />
            </ReactModal>
            <div className="flex-between">
                <div className="flex-center">
                    <span className="icon-before-cat">
                        <CategoryIcon
                            component={{ icon: CategoryIcons.getIconUrlByName(selectedCategory.images && selectedCategory.images.length > 0 ? selectedCategory.images[0] : '') }}
                        />
                    </span>
                    {active ? <div>
                        <h1 className="main-title">
                            <div className="info info-title" data-info="item_name">
                                <input
                                    id="item_name"
                                    disabled={edited}
                                    defaultValue={selectedCategory.name}
                                    name="item_name"
                                    value={selectedCategory.name}
                                    placeholder='Group Name'
                                    onChange={({ target: { value } }) => {
                                        setSelectedCategory({ ...selectedCategory, name: value })
                                    }}
                                />
                            </div>
                        </h1>
                        <a onClick={enableInput} className="edit-title">
                            {getTranslatedText('edit', store)}
                        </a>
                    </div> : <span>{selectedCategory.name} - {getTranslatedText('weSuggest', store)}</span>}
                </div>
                <button
                    type="button"
                    className="btn default-btn"
                    data-type="select-item-modal"
                    onClick={() => {
                        openModal();
                    }}
                    data-attribute="modal-action">
                    {getTranslatedText('selectItems', store)}
                </button>
            </div>

          
                 <div className="grid has-col-15 border-bottom padding-top-double padding-bottom">
                    <div className="grid-item custom-grid-1-1 grid-start">
                    </div>
                    <div className="grid-item custom-grid-2-4">
                        <h3 className="clearfix">{getTranslatedText('rootCategoryItems', store)}</h3>
                    </div>
                     {isDineIn && (
                         <>
                            <div className="grid-item custom-grid-3-2">
                                <p className="mods-filter-opt text-center">{getTranslatedText('filter', store)}</p>
                            </div>
                            <div className="grid-item custom-grid-4-2">
                                <p className="text-center">{getTranslatedText('price', store)}</p>
                            </div>
                            <div className="grid-item custom-grid-5-2">
                                <p className="text-center">{getTranslatedText('availability', store)}</p>
                            </div>
                            <div className="grid-item custom-grid-6-1">

                            </div>
                        </>
                     )}
                </div>

            {active ?
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId='rootCategoryItems'>
                        {provided =>
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {draggedList && draggedList.map((categoryItem, index) =>
                                    <Draggable key={index} index={index} draggableId={`${categoryItem.name}${categoryItem.id}`}>
                                        {provided =>
                                            <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                {!categoryItem.suggested &&
                                                    <div key={index}>
                                                        <div className="grid has-col-15 padding-top padding-bottom">
                                                            <div className="grid-item custom-grid-2-4 pointer" onClick={() => history.push(`/add-rootCategory-item/${categoryItem.id}`)}>
                                                                <div className="image-wrapper grid-flex flex-start-center">
                                                                    <div style={{ marginLeft: -60, marginRight: 30 }}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#ffffff" class="bi bi-list" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" /> </svg>
                                                                    </div>
                                                                    <span className="image-container">
                                                                        <img src={HCNImages.getFullImageURL(categoryItem.images[0], categoryItem.images[0]?.thumbnail ? 'thumbnail' : categoryItem.images[0]?.default ? 'default' : 'main')} width="100" />
                                                                        <span className="default-image-layer"></span>
                                                                    </span>
                                                                    <div className="margin-left-half">
                                                                        <p>{categoryItem.name}</p>
                                                                        {categoryItem.description ? <p className="text-small margin-top-half">{categoryItem.description}</p> : <></>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {isDineIn && (
                                                                <>
                                                                    <div className="grid-item custom-grid-3-2 grid-center">
                                                                        <div className="filters-wrapper flex-center">
                                                                            {categoryItem.filters && categoryItem.filters.filter(filter => filter && filter.name).map(filter => filter.name).map((filterName, index) => <span key={index + 'fname'} className="filter-circle-small flex-center">{filterName && filterName.toUpperCase().split(' ').map(it => it[0]).join('')}</span>)}
                                                                        </div>
                                                                        </div>
                                                                        <div className="grid-item custom-grid-4-2 grid-center">
                                                                            <p className="mods-price">{HCNPrice.format(categoryItem.price2 ? categoryItem.price2 : categoryItem.price)}</p>
                                                                        </div>
                                                                        <div className="grid-item custom-grid-5-2 grid-center">
                                                                            <label className="switch">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={categoryItem.available}
                                                                                    onChange={event => {
                                                                                        changeRootCategoryItemAvailability(categoryItem.id, event.target.checked);
                                                                                        categoryItem.available = event.target.checked;
                                                                                        categoryItems[categoryItems.findIndex(c => c.id === categoryItem.id)] = categoryItem;
                                                                                        setCategoryItems([...categoryItems]);
                                                                                    }}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                    </div>
                                                                </>
                                                            )}
                                                            <div className="grid-item custom-grid-6-1 grid-end-center">
                                                                <button className="remove" onClick={(event) => {
                                                                    event.preventDefault();
                                                                    removeCategoryItem(categoryItem.id);
                                                                }}>
                                                                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M27.3356 4.33917H2.07271C1.70054 4.33917 1.34361 4.49153 1.08044 4.76273C0.817278 5.03393 0.669434 5.40175 0.669434 5.78528C0.669434 6.16881 0.817278 6.53663 1.08044 6.80783C1.34361 7.07903 1.70054 7.23139 2.07271 7.23139H4.87992V24.5874C4.87992 25.7382 5.32352 26.8418 6.11314 27.6555C6.90276 28.4693 7.97371 28.9264 9.0904 28.9264H20.3179C21.4346 28.9264 22.5056 28.4693 23.2952 27.6555C24.0848 26.8418 24.5284 25.7382 24.5284 24.5874V7.23139H27.3356C27.7078 7.23139 28.0647 7.07903 28.3279 6.80783C28.591 6.53663 28.7389 6.16881 28.7389 5.78528C28.7389 5.40175 28.591 5.03393 28.3279 4.76273C28.0647 4.49153 27.7078 4.33917 27.3356 4.33917ZM13.3009 20.2484C13.3049 20.441 13.2716 20.6325 13.2029 20.8116C13.1342 20.9907 13.0314 21.1539 12.9007 21.2916C12.77 21.4293 12.6139 21.5387 12.4416 21.6133C12.2693 21.688 12.0842 21.7265 11.8973 21.7265C11.7104 21.7265 11.5253 21.688 11.353 21.6133C11.1807 21.5387 11.0246 21.4293 10.8939 21.2916C10.7631 21.1539 10.6604 20.9907 10.5917 20.8116C10.5229 20.6325 10.4896 20.441 10.4937 20.2484V13.0172C10.4896 12.8246 10.5229 12.6331 10.5917 12.454C10.6604 12.2748 10.7631 12.1116 10.8939 11.974C11.0246 11.8363 11.1807 11.7269 11.353 11.6522C11.5253 11.5775 11.7104 11.5391 11.8973 11.5391C12.0842 11.5391 12.2693 11.5775 12.4416 11.6522C12.6139 11.7269 12.77 11.8363 12.9007 11.974C13.0314 12.1116 13.1342 12.2748 13.2029 12.454C13.2716 12.6331 13.3049 12.8246 13.3009 13.0172V20.2484ZM18.9146 20.2484C18.9187 20.441 18.8854 20.6325 18.8167 20.8116C18.7479 20.9907 18.6452 21.1539 18.5145 21.2916C18.3837 21.4293 18.2276 21.5387 18.0553 21.6133C17.883 21.688 17.698 21.7265 17.511 21.7265C17.3241 21.7265 17.1391 21.688 16.9668 21.6133C16.7945 21.5387 16.6384 21.4293 16.5076 21.2916C16.3769 21.1539 16.2741 20.9907 16.2054 20.8116C16.1367 20.6325 16.1034 20.441 16.1074 20.2484V13.0172C16.1034 12.8246 16.1367 12.6331 16.2054 12.454C16.2741 12.2748 16.3769 12.1116 16.5076 11.974C16.6384 11.8363 16.7945 11.7269 16.9668 11.6522C17.1391 11.5775 17.3241 11.5391 17.511 11.5391C17.698 11.5391 17.883 11.5775 18.0553 11.6522C18.2276 11.7269 18.3837 11.8363 18.5145 11.974C18.6452 12.1116 18.7479 12.2748 18.8167 12.454C18.8854 12.6331 18.9187 12.8246 18.9146 13.0172V20.2484Z"
                                                                            fill="white" />
                                                                        <path
                                                                            d="M11.8964 2.89215H17.5109C17.8831 2.89215 18.24 2.7398 18.5032 2.46861C18.7663 2.19741 18.9142 1.8296 18.9142 1.44608C18.9142 1.06255 18.7663 0.694737 18.5032 0.423546C18.24 0.152354 17.8831 8.08214e-09 17.5109 0H11.8964C11.5243 8.08214e-09 11.1673 0.152354 10.9042 0.423546C10.641 0.694737 10.4932 1.06255 10.4932 1.44608C10.4932 1.8296 10.641 2.19741 10.9042 2.46861C11.1673 2.7398 11.5243 2.89215 11.8964 2.89215Z"
                                                                            fill="white" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="hr-line-gray"></div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </Draggable>,
                                )}
                                {provided.placeholder}
                            </div>
                        }
                    </Droppable>
                </DragDropContext>
                : <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId='rootCategoryItems'>
                        {provided =>
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {draggedList && draggedList.map((categoryItem, index) =>
                                    <Draggable key={index} index={index} draggableId={`${categoryItem.name}${categoryItem.id}`}>
                                        {provided =>
                                            <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                {categoryItem.suggested &&
                                                    <div key={index}>
                                                        <div className="grid has-col-15 padding-top padding-bottom">
                                                            <div className="grid-item custom-grid-2-4 pointer" onClick={() => history.push(`/add-rootCategory-item/${categoryItem.id}`)}>
                                                                <div className="image-wrapper grid-flex">
                                                                    <div style={{ marginLeft: -60, marginRight: 30, marginTop: 30 }}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#ffffff" class="bi bi-list" viewBox="0 0 16 16"> <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" /> </svg>
                                                                    </div>
                                                                    <span className="image-container">
                                                                        <img src={HCNImages.getFullImageURL(categoryItem.images && categoryItem.images[0], categoryItem.images[0]?.thumbnail ? 'thumbnail' : categoryItem.images[0]?.default ? 'default' : 'main')} width="100" />
                                                                        <span className="default-image-layer"></span>
                                                                    </span>
                                                                    <div className="margin-left-half">
                                                                        <p>{categoryItem.name}</p>
                                                                        {categoryItem.description ? <p className="text-small margin-top-half">{categoryItem.description}</p> : <></>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <>
                                                                <div className="grid-item custom-grid-3-2 grid-center">
                                                                    <div className="filters-wrapper flex-center">
                                                                        {categoryItem.filters && categoryItem.filters
                                                                            .filter(filter => filter && filter.name)
                                                                            .map(filter => filter.name)
                                                                            .map((filterName, index) =>
                                                                                <span key={index + 'fname'} className="filter-circle-small flex-center">
                                                                                    {filterName && filterName.toUpperCase().split(' ').map(it => it[0]).join('')}
                                                                                </span>,
                                                                            )}
                                                                    </div>
                                                                </div>
                                                                <div className="grid-item custom-grid-4-2 grid-center">
                                                                    <p className="mods-price">{HCNPrice.format(categoryItem.price2 ? categoryItem.price2 : categoryItem.price)}</p>
                                                                </div>
                                                                <div className="grid-item custom-grid-5-2 grid-center">
                                                                    <label className="switch">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={categoryItem.available}
                                                                            onChange={event => {
                                                                                changeRootCategoryItemAvailability(categoryItem, event.target.checked);
                                                                                categoryItem.available = event.target.checked;
                                                                                categoryItems[categoryItems.findIndex(c => c.id === categoryItem.id)] = categoryItem;
                                                                                setCategoryItems([...categoryItems]);
                                                                            }}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                </div>
                                                            </>
                                                            <div className="grid-item custom-grid-6-1 grid-end-center">
                                                                <button className="remove" onClick={(event) => {
                                                                    event.preventDefault();
                                                                    removeCategoryItem(categoryItem.id);
                                                                }}>
                                                                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M27.3356 4.33917H2.07271C1.70054 4.33917 1.34361 4.49153 1.08044 4.76273C0.817278 5.03393 0.669434 5.40175 0.669434 5.78528C0.669434 6.16881 0.817278 6.53663 1.08044 6.80783C1.34361 7.07903 1.70054 7.23139 2.07271 7.23139H4.87992V24.5874C4.87992 25.7382 5.32352 26.8418 6.11314 27.6555C6.90276 28.4693 7.97371 28.9264 9.0904 28.9264H20.3179C21.4346 28.9264 22.5056 28.4693 23.2952 27.6555C24.0848 26.8418 24.5284 25.7382 24.5284 24.5874V7.23139H27.3356C27.7078 7.23139 28.0647 7.07903 28.3279 6.80783C28.591 6.53663 28.7389 6.16881 28.7389 5.78528C28.7389 5.40175 28.591 5.03393 28.3279 4.76273C28.0647 4.49153 27.7078 4.33917 27.3356 4.33917ZM13.3009 20.2484C13.3049 20.441 13.2716 20.6325 13.2029 20.8116C13.1342 20.9907 13.0314 21.1539 12.9007 21.2916C12.77 21.4293 12.6139 21.5387 12.4416 21.6133C12.2693 21.688 12.0842 21.7265 11.8973 21.7265C11.7104 21.7265 11.5253 21.688 11.353 21.6133C11.1807 21.5387 11.0246 21.4293 10.8939 21.2916C10.7631 21.1539 10.6604 20.9907 10.5917 20.8116C10.5229 20.6325 10.4896 20.441 10.4937 20.2484V13.0172C10.4896 12.8246 10.5229 12.6331 10.5917 12.454C10.6604 12.2748 10.7631 12.1116 10.8939 11.974C11.0246 11.8363 11.1807 11.7269 11.353 11.6522C11.5253 11.5775 11.7104 11.5391 11.8973 11.5391C12.0842 11.5391 12.2693 11.5775 12.4416 11.6522C12.6139 11.7269 12.77 11.8363 12.9007 11.974C13.0314 12.1116 13.1342 12.2748 13.2029 12.454C13.2716 12.6331 13.3049 12.8246 13.3009 13.0172V20.2484ZM18.9146 20.2484C18.9187 20.441 18.8854 20.6325 18.8167 20.8116C18.7479 20.9907 18.6452 21.1539 18.5145 21.2916C18.3837 21.4293 18.2276 21.5387 18.0553 21.6133C17.883 21.688 17.698 21.7265 17.511 21.7265C17.3241 21.7265 17.1391 21.688 16.9668 21.6133C16.7945 21.5387 16.6384 21.4293 16.5076 21.2916C16.3769 21.1539 16.2741 20.9907 16.2054 20.8116C16.1367 20.6325 16.1034 20.441 16.1074 20.2484V13.0172C16.1034 12.8246 16.1367 12.6331 16.2054 12.454C16.2741 12.2748 16.3769 12.1116 16.5076 11.974C16.6384 11.8363 16.7945 11.7269 16.9668 11.6522C17.1391 11.5775 17.3241 11.5391 17.511 11.5391C17.698 11.5391 17.883 11.5775 18.0553 11.6522C18.2276 11.7269 18.3837 11.8363 18.5145 11.974C18.6452 12.1116 18.7479 12.2748 18.8167 12.454C18.8854 12.6331 18.9187 12.8246 18.9146 13.0172V20.2484Z"
                                                                            fill="white" />
                                                                        <path
                                                                            d="M11.8964 2.89215H17.5109C17.8831 2.89215 18.24 2.7398 18.5032 2.46861C18.7663 2.19741 18.9142 1.8296 18.9142 1.44608C18.9142 1.06255 18.7663 0.694737 18.5032 0.423546C18.24 0.152354 17.8831 8.08214e-09 17.5109 0H11.8964C11.5243 8.08214e-09 11.1673 0.152354 10.9042 0.423546C10.641 0.694737 10.4932 1.06255 10.4932 1.44608C10.4932 1.8296 10.641 2.19741 10.9042 2.46861C11.1673 2.7398 11.5243 2.89215 11.8964 2.89215Z"
                                                                            fill="white" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="hr-line-gray"></div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </Draggable>,
                                )}
                                {provided.placeholder}
                            </div>
                        }
                    </Droppable>
                </DragDropContext>
            }
        </div>
    );
};

export default RootCategoryItems;
